import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 3),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  iconBox: {
    width: 40,
    height: 40,
    flex: 'none',
    borderRadius: 9,
    display: 'grid',
    placeItems: 'center',
    color: theme.palette.secondary.main,
    backgroundColor: theme.palette.background.default,
    border: `1px solid ${theme.palette.divider}`,
  },
  text: {
    flex: '1 1 auto',
    minWidth: 0,
  },
  title: {
    fontWeight: 700,
    fontSize: 15,
    color: theme.palette.text.primary,
  },
  subtitle: {
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  controls: {
    display: 'flex',
    flex: 'none',
  },
  tail: {
    width: 34,
    flex: 'none',
  },
}))

export default useStyles
